import BaseData from './model/baseData'


import {groupStatReport, tenantStatReport} from './api'

export default class EventTrackingService {
    async groupStatReport(params: BaseData[]):Promise<any>{
        let {data} = await groupStatReport(params)
        return data
    }
    async tenantStatReport(params: BaseData[]):Promise<any>{
        let {data} = await tenantStatReport(params)
        return data
    }
}